import React from "react";

const WorkoutCatCount = ({ uniqueExercises }) => {
  return (
    <div className="added-count">
      <p className="headline">Total Exercises Added</p>

      <div className="exercise-cat-counts">
        {uniqueExercises.map((cat, index) => (
          <div className="cat-name-count" key={index}>
            <span className="label">{cat?.name || "NA"}</span>
            <span className="count">{cat?.occurrences || 0}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkoutCatCount;
